import { render, staticRenderFns } from "./SysNotifications.vue?vue&type=template&id=5cb19003&scoped=true&"
import script from "./SysNotifications.vue?vue&type=script&lang=js&"
export * from "./SysNotifications.vue?vue&type=script&lang=js&"
import style0 from "./SysNotifications.vue?vue&type=style&index=0&id=5cb19003&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb19003",
  null
  
)

export default component.exports